import { IResourceComponentsProps } from "@pankod/refine-core";
import {
  Create,
  useForm,
} from "@pankod/refine-antd";
import { ISellers } from "interfaces";
import { SellersForm } from "components/forms";

export const SellersCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<ISellers>();
  return (
    <Create saveButtonProps={saveButtonProps}>
      <SellersForm
        formProps={formProps}
        queryResult={queryResult}
      />
    </Create>
  );
};
